var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45074 15.2C7.17612 15.2 6.90144 15.0122 6.90144 14.8244V1.17571C6.90144 0.987879 7.17612 0.800049 7.45074 0.800049C7.72537 0.800049 8 0.987879 8 1.17571V14.8244C8 15.0122 7.72537 15.2 7.45074 15.2ZM0.5493 15.2C0.274627 15.2 0 15.0122 0 14.8244V1.17571C0 0.987879 0.274627 0.800049 0.5493 0.800049C0.823928 0.800049 1.09856 0.987879 1.09856 1.17571V14.8244C1.09856 15.0122 0.823928 15.2 0.5493 15.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.27d750ae91111cb5a0123af72212b2e8.svg";
export { ForwardRef as ReactComponent };